import { Component, Inject, OnInit, Optional } from '@angular/core';
import { Grid } from '@app/core/components/grid/grid.model';
import { GridOptions } from '@app/core/components/grid/grid.types';
import { TT_VIEW_NAVIGATOR, TTViewNavigator, useNavigatorFor } from '@app/modal/state-modal/state-modal.component';

@Component({
  selector: 'tt-customer-bonus',
  templateUrl: './customer-bonus.component.html',
  styleUrls: ['./customer-bonus.component.css'],
  standalone: false,
})
export class CustomerBonusComponent implements OnInit {
    public grid?: GridOptions;

    constructor(@Optional() @Inject(TT_VIEW_NAVIGATOR) private navigator?: TTViewNavigator) {
        this.navigator = useNavigatorFor(navigator, this);
    }

    public ngOnInit(): void {
        const custNo = this.navigator?.params['cust_no'];
        if (typeof custNo !== 'string' && typeof custNo !== 'number') return;

        this.grid = new Grid()
            .setRememberId('w_customerBonus.grid')
            .setLoadDataFunction({ method: 2843, parameters: { cust_no: custNo } })
            .setToolbar({ pdfExport: false, excelExport: false, wrapping: false, layouts: false })
            .setSpecialFunc({ newTab: true })
            .setKendoConfig({ height: null, aggregate: true, pager: false, selectable: false, filterable: false });
    }
}
